import React from 'react';
import { Grid } from '@mui/material';
import MonthlyGraph from './MonthlyGraph';
import { AdminAnalyticsContext } from '../contexts/AdminAnalyticsContext';
import YearlyGraph from './YearlyGraph';

const OrdersAverageCharts: React.FunctionComponent = () => {
  const {
    ordersByMonthCharts,
    fetchOrdersByMonthCharts,
    ordersByMonthChartsLoading,
    ordersByYearCharts,
    ordersByYearChartsLoading,
    selectedYear,
    setSelectedYear,
    fetchOrdersByYearCharts,
    showMonthly,
    setShowMonthly,
  } = React.useContext(AdminAnalyticsContext);

  React.useEffect(() => {
    fetchOrdersByYearCharts();
  }, []);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <YearlyGraph
            title="Average Orders Per Machine Per Year"
            labels={ordersByYearCharts.years}
            values={ordersByYearCharts.avg_order_count_per_machine}
            loading={ordersByYearChartsLoading}
            fetchFunction={(year) => {
              fetchOrdersByMonthCharts(year);
              setShowMonthly(true);
            }}
            yearSetter={(year) => {
              setSelectedYear(year);
            }}
          />
        </Grid>
      </Grid>
      {showMonthly && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <br />
            <MonthlyGraph
              title="Average Orders Per Machine Per Month"
              labels={ordersByMonthCharts.month}
              values={ordersByMonthCharts.avg_order_count_per_machine}
              loading={ordersByMonthChartsLoading}
              year={selectedYear}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default OrdersAverageCharts;
